import { t } from "@lingui/core/macro";
import { Color } from "@fidelix/fx-miranda";
import { AlarmBase } from "./alarm.model";

export type AlarmTab = "active" | "unacknowledged" | "all";

export function getAlarmListTitle(tab: AlarmTab) {
  switch (tab) {
    case "unacknowledged": {
      return t`Unacknowledged Alarms`;
    }
    case "active": {
      return t`Active Alarms`;
    }
    default: {
      return t`All Alarms`;
    }
  }
}

export function getAlarmActiveStatusText(isActive?: boolean) {
  switch (isActive) {
    case true:
      return t`Active`;
    case false:
      return t`Inactive`;
    default:
      return t`Unknown`;
  }
}
export function getAlarmStateText(alarm: AlarmBase) {
  switch (alarm.value?.isAcknowledged) {
    case false:
      return t`Unacknowledged`;
    case undefined:
    case null:
      return "-";
    default:
      return t`Acknowledged`;
  }
}

export function getAlarmStateBadgeColor(alarm: AlarmBase): Color {
  if (!alarm.value) {
    return "error";
  }

  const { isAcknowledged, isActive } = alarm.value;

  if (isAcknowledged === true && isActive === false) {
    return "success";
  } else if (isAcknowledged === false && isActive === false) {
    return "warning";
  } else if (isAcknowledged === true && isActive === true) {
    return "errorLight";
  }
  return "error";
}
